import { ThemeStore } from '@monorepo/client-common';
import { EnvService } from '../services/core/env-service';
import DataStore from './data/data-store';
import UiStore from './ui/ui-store';

const { appEnv, application } = EnvService.get();

// eslint-disable-next-line
interface IRootStore {
  uiStore: UiStore;
  dataStore: DataStore;
  themeStore: ThemeStore;
}

// eslint-disable-next-line
class RootStore implements IRootStore {
  uiStore: UiStore = {} as UiStore;
  dataStore: DataStore = {} as DataStore;
  themeStore: ThemeStore = {} as ThemeStore;

  // Used by mobx-easy
  init() {
    this.uiStore = new UiStore({ reactEnv: appEnv });
    this.dataStore = new DataStore();
    this.themeStore = new ThemeStore({ project: application });
  }
}

export default RootStore;
